import "./search-all-filter.css";

import type { InputChangeEvent } from "@tql/ui-components-react/kendo/inputs";
import { Input } from "@tql/ui-components-react/kendo/inputs";
import { Label } from "@tql/ui-components-react/kendo/labels";

type SearchAllFilterProps = {
	value: string;
	onChange: (value: string) => void;
};

export const SearchAllFilter = ({ value, onChange }: SearchAllFilterProps) => {
	const handleChange = (event: InputChangeEvent) => {
		onChange(String(event.value ?? ""));
	};

	return (
		<div className={"search-all-filter"}>
			<Label className={"k-form-label"}>Search All</Label>
			<Input
				aria-label={"Search all loads"}
				onChange={handleChange}
				placeholder={"Search by any field..."}
				value={value}
			/>
		</div>
	);
};
